import React from 'react';

import { css } from '@emotion/react';

import theme from '../../theme';

export const globalStyles = css`
    /* DateRangePicker Styles */
    .date-range-picker {
        .rdp-day_selected:not(.rdp-day_outside) {
            background-color: #f0f8ff;
            color: ${theme.color.jetBlack};
        }
        .rdp-day_selected {
            border-radius: 0;
        }
    }
`;
